// src/home/components/layout/Header.js
import React, { useState, useEffect, useRef } from 'react';
import '../../styles/Header.css';
//import emblem from '../../assets/image/emblem.png';
//import userGuide from '../../assets/documents/userguide.pdf';
import userGuide from '../../assets/documents/DP_Part Plan_SMKMC.pdf';
import emblem from '../../assets/image/logo1.png';

import { FaGlobe, FaChevronDown } from 'react-icons/fa';
import { tHeader, setLanguage, currentLanguage } from '../../services/LanguageTranslationService';
  
const Header = ({ onLoginClick, onOfficeClick }) => {
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(currentLanguage);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowLanguageDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleLanguageDropdown = () => {
    setShowLanguageDropdown(!showLanguageDropdown);
  };

  const handleLanguageChange = (language) => {
    const langCode = language === 'Marathi' ? 'mr' : 'en';
    setSelectedLanguage(langCode);
    setLanguage(langCode);
    setShowLanguageDropdown(false);
    window.location.reload(); // Refresh to update all translations
  };

  const getDisplayLanguage = () => {
    return selectedLanguage === 'mr' ? 'मराठी' : 'English';
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <img src={emblem} alt="Government Emblem" className="emblem" />
          <div className="title-container">
            <h1>{tHeader('header.title')}</h1>
            <p className="subtitle">{tHeader('header.subtitle')}</p>
            <p className="subSubtitle">{tHeader('header.subSubtitle')}</p>
          </div>
        </div>
        <div className="auth-buttons">
          <button className="auth-btn applicant-login" onClick={onLoginClick}>
            {tHeader('header.applicantLogin')}
          </button>
          <button className="auth-btn branch-login" onClick={onOfficeClick}>
            {tHeader('header.officeLogin')}
          </button>
        </div>
      </div>
      <nav className="main-nav">
        <ul className="nav-list">
          <li><a href="#home" className="active">{tHeader('header.home')}</a></li>
          <li><a href="#faq">{tHeader('header.faq')}</a></li>
          <li><a href="#contact">{tHeader('header.contact')}</a></li>
          <li className="language-dropdown" ref={dropdownRef}>
            <div className="language-selector" onClick={toggleLanguageDropdown}>
              <FaGlobe className="language-icon" />
              <span>{getDisplayLanguage()}</span>
              <FaChevronDown className={`dropdown-icon ${showLanguageDropdown ? 'rotate' : ''}`} />
            </div>
            {showLanguageDropdown && (
              <ul className="dropdown-menu">
                <li onClick={() => handleLanguageChange('English')}>
                  <span role="img" aria-label="English">🇬🇧</span> English
                </li>
                <li onClick={() => handleLanguageChange('Marathi')}>
                  <span role="img" aria-label="Marathi">🇮🇳</span> मराठी
                </li>
              </ul>
            )}
          </li>
          <li><a href={userGuide} download="userguide.pdf">{tHeader('header.userGuide')}</a></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;